export default {
  namespaced: true,
  state: {
    isError: false,
    errorMessage: false,
    isOperational: false, //是否為操作過程中發生的，非api回傳
  },
  mutations: {
    SET_ISOPERATIONAL_TRUE(state) {
      state.isOperational = true;
    },
    SET_ISOPERATIONAL_FALSE(state) {
      state.isOperational = false;
    },
    SET_ERROR_TRUE(state) {
      state.isError = true;
    },
    SET_ERROR_FALSE(state) {
      state.isError = false;
    },
    SET_ERROR_MESSAGE(state, data) {
      state.errorMessage = data;
    },
  },
  actions: {
    setIsOperationalTrue({ commit }, data) {
      commit('SET_ISOPERATIONAL_TRUE', data);
    },
    setIsOperationalFalse({ commit }, data) {
      commit('SET_ISOPERATIONAL_FALSE', data);
    },
    setErrorTrue({ commit }, data) {
      commit('SET_ERROR_TRUE', data);
    },
    setErrorFalse({ commit }, data) {
      commit('SET_ERROR_FALSE', data);
    },
    setErrorMessage({ commit }, data) {
      commit('SET_ERROR_MESSAGE', data);
    },
  },
};
